import axios from "axios";
import {storageService} from "../utils";
import {
  GetGlobalAccountUuidReducer,
  GetGlobalCompanyId,
  GlobalNavigate,
} from "./Middleware.Helper";
import i18next from "i18next";

function renderByStatusCode(statusCode) {
  switch (statusCode) {
    // case 400:
    //   GlobalNavigate('/recruiter/400');
    //   break;
    // case 401:
    //   GlobalNavigate('/recruiter/401');
    //   break;
    case 402:
      GlobalNavigate("/recruiter/no-subscriptions");
      break;
    // case 404:
    //   GlobalNavigate("/recruiter/404");
    //   break;
    // case 406:
    //   break;
    // case 422:
    //   GlobalNavigate('recruiter/422');
    //   break;
    // case 429:
    //   GlobalNavigate('recruiter/429');
    //   break;
    // case 500:
    //   GlobalNavigate('recruiter/500');
    //   break;
    default:
      break;
  }
}

export let CurrentTabInProgressAPIs = 0;

const allPendingRequestsRecord = [];
const getUniqueId = (config) => `url=${config.url}&method=${config.method}`;

axios.interceptors.request.use(
  (configurations) => {
    const configurationsLocal = configurations;
    // a counter for the progress APIs
    const requestsCounter = localStorage.getItem("APIRequestsCounter")
      ? +localStorage.getItem("APIRequestsCounter")
      : 0;
    CurrentTabInProgressAPIs += 1;
    localStorage.setItem("APIRequestsCounter", requestsCounter + 1 + "");
    configurationsLocal.cancelToken = new axios.CancelToken((cancel) => {
      // Add record, record the unique value of the request and cancel method
      allPendingRequestsRecord.push({
        id: getUniqueId(configurations),
        cancel,
      });
    });
    const companyId = GetGlobalCompanyId();
    const localCompanyUuid = localStorage.getItem("company_uuid") || "";
    const localUserToken = localStorage.getItem("user_token") || "";
    const userToken = localStorage.getItem("user_token") || "";
    const localAccountUuid = localStorage.getItem("account_uuid") || "";
    const account_uuid = GetGlobalAccountUuidReducer() || "";

    if (!configurationsLocal.headers.isPublic)
      configurationsLocal.headers = {
        "Content-Type":
          configurationsLocal.headers["Content-Type"] || "application/json",
        Accept: configurationsLocal.headers["Accept"] || "application/json",
        "Accept-Company":
          configurationsLocal.headers["Accept-Company"] ||
          companyId ||
          localCompanyUuid,
        "Accept-Account": account_uuid || localAccountUuid,
        "Accept-Language": i18next.language,
        Authorization: `Bearer ${userToken || localUserToken}`,
      };
    else
      configurationsLocal.headers = {
        "Content-Type":
          configurationsLocal.headers["Content-Type"] || "application/json",
        Accept: configurationsLocal.headers["Accept"] || "application/json",
        "Accept-Language": i18next.language,
      };

    configurationsLocal.headers["X-Frame-Options"] = "SAMEORIGIN";

    return configurationsLocal;
  },
  (error) => {
    Promise.reject(error);
  }
);

export const removeAllPendingRequestsRecordHttp = () => {
  allPendingRequestsRecord.forEach((item) => {
    item.cancel("page changes"); // cancel request
  });
  allPendingRequestsRecord.splice(0); // remove all records
};

// interceptors for the handle any response
axios.interceptors.response.use(
  (response) => {
    // a counter for the progress APIs
    const requestsCounter = localStorage.getItem("APIRequestsCounter")
      ? +localStorage.getItem("APIRequestsCounter")
      : 0;
    CurrentTabInProgressAPIs -= 1;
    localStorage.setItem("APIRequestsCounter", requestsCounter - 1 + "");

    return response;
  },
  (error) => {
    if (CurrentTabInProgressAPIs > 0) {
      // a counter for the progress APIs
      const requestsCounter = localStorage.getItem("APIRequestsCounter")
        ? +localStorage.getItem("APIRequestsCounter")
        : 0;
      if (requestsCounter > 0) {
        CurrentTabInProgressAPIs -= 1;
        localStorage.setItem("APIRequestsCounter", requestsCounter - 1 + "");
      } else {
        CurrentTabInProgressAPIs = 0;
        localStorage.setItem("APIRequestsCounter", "0");
      }
    } else {
      CurrentTabInProgressAPIs = 0;
      localStorage.setItem("APIRequestsCounter", "0");
    }
    if (!error.response) return Promise.reject(error);
    const {
      response: {status},
    } = error;
    // Do something with response error
    // if (status === 402)
    //   ShowError(error?.response?.data?.status);
    if (status === 401)
      if (process.env.REACT_APP_DEBUG === "false") {
        if (
          error.response?.data?.message === "invalid_credentials" ||
          error.response?.data?.message ===
            "Incorrect email address or password, please try again" ||
          error.response?.data?.message ===
            "Your organization's account has been suspended. please contact your organization administrator"
        )
          return Promise.reject(error);

        // If the session is out of the date, clear
        // the session and local storage then redirect to login page.
        if (error?.response?.data?.token_error) {
          storageService.clearLocalStorage();
          GlobalNavigate("/accounts/login");

          return Promise.reject(error);
        }
      }
    const url = new URL(window.location.href);
    const query = new URLSearchParams(url.search);
    const isNotLoginPage = !url.pathname.includes("/accounts/");
    if (
      isNotLoginPage &&
      error.response.data?.identifiers?.status === "invalid_token"
    ) {
      storageService.clearLocalStorage();
      removeAllPendingRequestsRecordHttp();
      GlobalNavigate(`/accounts/login?${query.toString()}`);

      return Promise.reject(error);
    }
    renderByStatusCode(status);
    // if (error.response.error === 'permission') {
    //   renderByStatusCode(error.response.status, 'permission');
    // } else if (error.response.token_error === true) {
    //   renderByStatusCode(error.response.status, 'token_error');
    // }

    // if (error.response && error.response.status === 406)
    //   renderByStatusCode(error.response.status);

    // if (error.response && error.response.status === 500)
    //   // Report error to Sentry
    //   Sentry.withScope((scope) => {
    //     scope.setTag('type', 'server-error');
    //     Sentry.captureException(error);
    //   });

    // if (status === 422 || status === 429)
    //   ShowError('An error has occurred, Please try again');
    return Promise.reject(error);
  }
);

export const HttpServices = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  request: axios.request,
};
